export default {
  einsatzbereit: '180D641DEFD',
  nicht_einsatzbereit: '180D6342954',
};
